export default "__VITE_ASSET__DT5wup$3__"